'use client'

import { Box, IconButton, IconButtonProps, Theme, styled } from '@mui/material'
import React from 'react'

const OvalBox = styled(Box, { label: 'OvalBox' })(({ theme }) => ({
  display: 'flex',
  gap: '6px',
  flexDirection: 'column',
  // A translucent lift of the page rather than an outlined chip.
  backgroundColor: 'var(--dewi_pill_secondary)',
  border: 'none',
  width: '46px',
  height: '34px',
  borderRadius: '500px',
  padding: theme.spacing(1),
  paddingLeft: theme.spacing(1.7),
  paddingRight: theme.spacing(1.7),
  justifyContent: 'center',
  alignItems: 'center',
  boxSizing: 'border-box',
}))

const MenuLine = styled(Box, { label: 'MenuLine' })(
  ({
    theme,
    $hascloseicon,
    $rotatemult,
  }: {
    theme?: Theme
    $hascloseicon: string
    $rotatemult: string
  }) => ({
    borderRadius: '500px',
    backgroundColor: 'var(--dewi_colors_gray_0)',
    height: '2px',
    width: '100%',
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    transform: $hascloseicon
      ? `rotate(${Number($rotatemult) * 45}deg) ${
          Number($rotatemult) === 1
            ? 'translateX(3px) translateY(3px)'
            : 'translateX(2px) translateY(-3px)'
        }`
      : 'unset',
  }),
)

type MenuButtonProps = {
  hasCloseIcon: boolean
} & IconButtonProps

const MenuButton = ({ hasCloseIcon, ...rest }: MenuButtonProps) => {
  return (
    <IconButton {...rest}>
      <OvalBox>
        <MenuLine
          $hascloseicon={hasCloseIcon ? 'true' : undefined}
          $rotatemult="1"
        />
        <MenuLine
          $hascloseicon={hasCloseIcon ? 'true' : undefined}
          $rotatemult="-1"
        />
      </OvalBox>
    </IconButton>
  )
}

export default MenuButton
